/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { MEGA_BROKER_API } from '@tencent/mega-ipc-shared';
export var MegaPlayerEvent;
(function (MegaPlayerEvent) {
    // listen event
    MegaPlayerEvent["Play"] = "play";
    MegaPlayerEvent["Pause"] = "pause";
    MegaPlayerEvent["Stop"] = "stop";
    MegaPlayerEvent["Close"] = "close";
    MegaPlayerEvent["TogglePause"] = "toggle-pause";
    MegaPlayerEvent["ToggleMute"] = "toggle-mute";
    MegaPlayerEvent["SetVolume"] = "set-volume";
    MegaPlayerEvent["SetPosition"] = "set-position";
    MegaPlayerEvent["SetRate"] = "set-rate";
    MegaPlayerEvent["SetTime"] = "set-time";
    MegaPlayerEvent["SetMute"] = "set-mute";
    // emit event
    MegaPlayerEvent["FrameSetup"] = "frame-setup";
    MegaPlayerEvent["FrameReady"] = "frame-ready";
    MegaPlayerEvent["TimeChanged"] = "time-changed";
    MegaPlayerEvent["LengthChanged"] = "length-changed";
    MegaPlayerEvent["PositionChanged"] = "position-changed";
    MegaPlayerEvent["Opening"] = "opening";
    MegaPlayerEvent["Playing"] = "playing";
    MegaPlayerEvent["Paused"] = "paused";
    MegaPlayerEvent["Stopped"] = "stopped";
    MegaPlayerEvent["Backward"] = "backward";
    MegaPlayerEvent["Buffering"] = "buffering";
    MegaPlayerEvent["EncounteredError"] = "encountered-error";
    MegaPlayerEvent["EndReached"] = "end-reached";
    MegaPlayerEvent["Forward"] = "forward";
    MegaPlayerEvent["FrameCleanup"] = "frame-cleanup";
    MegaPlayerEvent["MediaChanged"] = "media-changed";
    MegaPlayerEvent["NothingSpecial"] = "nothing-special";
    MegaPlayerEvent["PausableChanged"] = "pausable-changed";
    MegaPlayerEvent["SeekableChanged"] = "seekable-changed";
    MegaPlayerEvent["LogMessage"] = "log-message";
})(MegaPlayerEvent || (MegaPlayerEvent = {}));
export const WEB_CHIMERA_API = `${MEGA_BROKER_API}:WebChimeraAPI`;
//# sourceMappingURL=mega-player-service.protocol.js.map